export default __webpack_public_path__ + "static/media/SourceSansPro-Regular.73ae3a58.ttf";